/* eslint-disable */
/**
 * confirm
 * @param {*} submitFun
 * @param {*} cancelFun
 */
export function confirm(content, title, submitFun, cancelFun) {
  this.$confirm(content, title, {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
    confirmButtonClass: 'show-del-submit'
  }).then(() => {
    submitFun && submitFun()
  }).catch(() => {
    cancelFun && cancelFun()
  })
}

/** 调用浏览器storage
 * @param key
 * @param value
 * @param boolean
 */
export function setStorage(key, value, boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.sessionStorage
  } else {
    storageObj = window.localStorage
  }
  if (Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]') {
    value = JSON.stringify(value)
  }
  if(key=='token'){
    console.log(value,typeof value)
  }
  storageObj.setItem(key, value)
}

export function getStorage(key, boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.sessionStorage
  } else {
    storageObj = window.localStorage
  }
  return storageObj.getItem(key)
}

export function removeStorage(key, boolean) {
  let storageObj = null
  if (boolean) {
    storageObj = window.sessionStorage
  } else {
    storageObj = window.localStorage
  }
  storageObj.removeItem(key)
}

/**
 * 格式化日期
 * @param  {[type]} fmt [description]
 * @return {[type]}     [description]
 */
export function DateFormat(time, fmt) {
  if (!time) return null;
  const date = new Date(time)
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  }
  return fmt;
}

// 获取8为随机数
export const generateRandomString = (index) => {
  let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomString = "";
  for (let i = 0; i < index; i++) {
    let randomIndex = Math.floor(Math.random() * chars.length);
    randomString += chars.charAt(randomIndex);
  }
  return randomString;
}

// 树形结构转为扁平的数组
export const flattenTree = (tree, children='children',result = []) => {
  if (!tree) return result; // 当前节点为空，返回结果数组
  result.push(tree); // 将当前节点加入结果数组
  // 递归处理子节点
  if (tree[children] && tree[children].length > 0) {
    for (let child of tree[children]) {
      flattenTree(child, children, result);
    }
  }
  return result;
}

// 扁平数组转换为树形结构
export const buildTree = (flatArray, parentId = null) => {
  const tree = [];

  flatArray.forEach(item => {
    if (item.parentId === parentId) {
      const children = buildTree(flatArray, item.id);
      if (children.length > 0) {
        item.children = children;
      }
      tree.push(item);
    }
  });

  return tree;
}

// 格式化文件大小
export const formatBytesSize = (size, fixed = 2) => {
  if (0 == size) return '0 B'
  let c = 1024;
  let d = fixed;
  let e = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let f = Math.floor(Math.log(size) / Math.log(c));
  return parseFloat((size / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
}

//
export const searchTree = (node, condition, menuNameData) => {
  const filteredChildren = (node.children || []).map(child => searchTree(child, condition, menuNameData)).filter(child => Object.keys(child).length !== 0);
  if (condition(node) || filteredChildren.length > 0) {
    // 如果满足条件，返回当前节点及其满足条件的子节点
    if (node && node.meta) node.meta.title = menuNameData[node.name];
    return {
      ...node,
      children: filteredChildren
    };
  } else {
    // 否则只返回满足条件的子节点
    return {};
  }
}
